import { jsxs as P, jsx as o } from "react/jsx-runtime";
import { u as T } from "./index-6a632112.mjs";
import { s as c, c as s } from "./themes-5f0b3c3d.mjs";
import { forwardRef as re, useState as C, useRef as oe, useEffect as H } from "react";
import { TextInput as ne } from "./textInput.js";
import { S as le } from "./cancelCloseFilled-b2127cb6.mjs";
import { S as ie } from "./caretDown-8ff83493.mjs";
import { S as ae } from "./caretUp-e6db3a6f.mjs";
import { S as K } from "./types-b577bf77.mjs";
import { D as V } from "./index-39f84169.mjs";
import { u as U } from "./uniqueId-321287e8.mjs";
import "./lineHeights-72d3110c.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
import "./label-3b996c7d.mjs";
import "./tooltip.js";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./iconButton.js";
import "./button.js";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./helperText-698f3ed9.mjs";
import "./warningFilled-691cfde1.mjs";
import "./radio.js";
import "./checkbox.js";
import "./checkmark-84b5274e.mjs";
import "./subtract-848336fd.mjs";
import "./menu.js";
import "./moreVertical-dc2e97a2.mjs";
function se({
  title: u,
  titleId: y,
  size: r,
  height: p,
  width: a,
  ...d
}) {
  const m = r ? K[r] : K.s;
  return /* @__PURE__ */ P(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: r ? m : p || m,
      width: r ? m : a || m,
      "aria-labelledby": y,
      ...d,
      children: [
        u ? /* @__PURE__ */ o("title", { id: y, children: u }) : null,
        /* @__PURE__ */ o("g", { clipPath: "url(#Clock_svg__a)", children: /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M36 10.8c-13.86 0-25.2 11.34-25.2 25.2S22.14 61.2 36 61.2 61.2 49.86 61.2 36 49.86 10.8 36 10.8Zm0 3.6c11.88 0 21.6 9.72 21.6 21.6S47.88 57.6 36 57.6 14.4 47.88 14.4 36 24.12 14.4 36 14.4Zm7.74 26.82c.72.72.72 1.8 0 2.52s-1.8.72-2.52 0l-5.94-5.94c-.72-.72-1.08-1.62-1.08-2.52V19.8c0-1.08.72-1.8 1.8-1.8s1.8.72 1.8 1.8v15.48l5.94 5.94Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ o("defs", { children: /* @__PURE__ */ o("clipPath", { id: "Clock_svg__a", children: /* @__PURE__ */ o("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
const j = "timePickerInput", ce = T.div`
  display: flex;
  width: 100%;
  // min-width: 280px;
  padding: var(--semantic-spacing-0-x, 0px);
  flex-direction: column;
  align-items: flex-start;
  gap: ${c["2x"]};
  && div[aria-disabled='true'] {
    filter: unset;
    opacity: unset;
    pointer-events: auto;
  }
  & input[disabled]::placeholder {
    color: ${s.brandTwilight[500]};
  }
`, ue = T.button`
  display: flex;
  height: ${c["6x"]};
  width: ${c["6x"]};
  padding: ${c["1x"]};
  justify-content: center;
  align-items: center;
  gap: var(--semantic-spacing-0-x, 0px);
  color: ${s.brandTwilight[800]};
  background-color: transparent;
  border: none;
  cursor: pointer;
  &:disabled {
    cursor: auto;
  }
  svg {
    height: ${c["4x"]};
    width: ${c["4x"]};
  }
`, pe = T.span`
  display: flex;
  align-items: center;
  gap: ${c["2x"]};
  ${(u) => {
  if (u.$hasClearIcon)
    return "margin-left: -32px";
}}
`, ze = re(
  ({
    placeholder: u = "Select time...",
    size: y = "medium",
    value: r = { inputValue: "", selectedValue: "" },
    format: p = "12",
    isDisabled: a = !1,
    isInvalid: d = !1,
    helperText: m,
    stepInterval: S = 60,
    minTime: O = "12:00 AM",
    maxTime: M = "11:00 PM",
    options: x,
    hasClearIcon: A = !1,
    isRequired: E = !1,
    required: D = E,
    onChange: b,
    onBlur: L,
    labelProp: N,
    infoProp: Z,
    trailingText: q,
    noResultText: W,
    helperTextProp: R = {
      [d ? "secondaryProp" : "defaultProp"]: {
        helperText: m,
        id: `${d ? "invalid" : "valid"}_${j}_helperText`,
        ...d && { state: "error" }
      }
    }
  }, z) => {
    const [$, _] = C([]), [B, g] = C([]), [k, F] = C(!1), I = oe(U(j)), J = {
      inputValue: "",
      selectedValue: ""
    };
    H(() => {
      x?.length ? (_(x), g(x)) : Y(S, O, M, p);
    }, [S, O, M, p, JSON.stringify(x)]), H(() => {
      const e = Q(r.inputValue?.toLowerCase());
      r.inputValue ? g(e || []) : g($);
    }, [r.inputValue, $]);
    const X = (e) => {
      e.stopPropagation(), b(J), g($);
    }, G = (e) => {
      const t = e.key.toUpperCase();
      if (/[0-9]/.test(t) || t === ":" || t === " " || p === "12" && (t === "A" || t === "P" || t === "M") || e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight" && e.key !== "ArrowUp" && e.key !== "ArrowDown" && e.key !== "Tab" && !(e.metaKey && e.key === "a") && // Command + A on Mac
      !(e.ctrlKey && e.key === "a") && e.preventDefault(), e.key === "Enter") {
        const l = B[0];
        b({
          inputValue: l.label,
          selectedValue: l.label
        });
      }
    }, Q = (e) => {
      if (e) {
        const [t, n] = ee(e), l = t?.replace(/[\s:]/g, "");
        return $.filter((f) => {
          const h = f.label.toLowerCase()?.replace(/[\s:]/g, "");
          return h.includes(`${l}`) && h.includes(n.toLowerCase());
        });
      }
    }, v = (e, t) => {
      const n = e.getHours(), l = e.getMinutes(), i = l < 10 ? "0" + l : l;
      if (t === "12") {
        const f = n >= 12 ? "PM" : "AM";
        return `${n % 12 || 12}:${i} ${f}`;
      } else
        return `${n < 10 ? `0${n}` : n}:${i}`;
    }, Y = (e, t, n, l) => {
      const i = [], f = /* @__PURE__ */ new Date(`01/01/2000 ${t}`), h = /* @__PURE__ */ new Date(`01/01/2000 ${n}`), w = new Date(f.getTime());
      for (; w.getTime() <= h.getTime(); ) {
        const te = {
          label: v(w, l),
          value: v(w, l)
        };
        i.push(te), w.setMinutes(w.getMinutes() + e);
      }
      _(i), g(i);
    };
    function ee(e) {
      let t = -1;
      if (p === "12") {
        for (let i = 0; i < e.length; i++)
          if (/^[amp]$/i.test(e[i])) {
            t = i;
            break;
          }
      }
      const n = t > 0 ? e.substring(0, t) : e, l = t > 0 ? e.substring(t) : "";
      return [n, l];
    }
    return /* @__PURE__ */ o(ce, { onBlur: (e) => {
      e.currentTarget.contains(e.relatedTarget) || L?.(e);
    }, children: /* @__PURE__ */ P(
      V,
      {
        menuOpen: !a && k,
        onChange: (e, t) => {
          b({
            inputValue: t.label,
            selectedValue: t.label
          });
        },
        closeOnSelect: !0,
        handleMenuOpen: (e) => F(e),
        isDisabled: a,
        uniqueIdentifier: I.current,
        noResultText: W || "No results found",
        children: [
          /* @__PURE__ */ o(V.Control, { children: /* @__PURE__ */ o(
            ne,
            {
              id: `control-${I.current}`,
              placeholder: u,
              value: r?.inputValue ? r?.inputValue : "",
              onChange: (e) => {
                e.target.value = e.target.value.toUpperCase().slice(0, 8), b({
                  inputValue: e.target.value,
                  selectedValue: `${r.selectedValue}`
                }), F(!0);
              },
              onKeyDown: G,
              startAdornment: /* @__PURE__ */ o(
                se,
                {
                  style: {
                    color: a ? s.brandTwilight[400] : s.brandTwilight[1e3]
                  }
                }
              ),
              endAdornment: /* @__PURE__ */ P(
                pe,
                {
                  $hasClearIcon: !!((r?.selectedValue && r.selectedValue?.length > 0 || r?.inputValue && r.inputValue?.length > 0) && A),
                  $isDisabled: a,
                  children: [
                    (!!r?.selectedValue || !!r?.inputValue) && A && /* @__PURE__ */ o(
                      ue,
                      {
                        onClick: X,
                        disabled: a,
                        "aria-label": "clear",
                        children: /* @__PURE__ */ o(le, {})
                      }
                    ),
                    k ? /* @__PURE__ */ o(
                      ae,
                      {
                        style: {
                          color: a ? s.brandTwilight[400] : s.brandTwilight[1e3]
                        }
                      }
                    ) : /* @__PURE__ */ o(
                      ie,
                      {
                        style: {
                          color: a ? s.brandTwilight[400] : s.brandTwilight[1e3]
                        }
                      }
                    )
                  ]
                }
              ),
              onKeyUp: (e) => {
                e.key === " " && e.stopPropagation();
              },
              textSize: y,
              disabled: a,
              isInvalid: d,
              showErrorIcon: !1,
              required: D,
              labelProp: {
                showRequiredIndicator: D,
                ...N
              },
              infoProp: { ...Z },
              ref: z,
              trailingText: q,
              helperTextProp: k ? {
                secondaryProp: {
                  state: R?.secondaryProp?.state || "none"
                }
              } : R
            }
          ) }),
          B?.map(({ label: e, value: t, disabled: n }) => /* @__PURE__ */ o(
            V.Item,
            {
              label: e,
              value: t || e,
              disabled: !!n,
              isSelected: r.selectedValue === t
            },
            `${t}_${U(t)}`
          ))
        ]
      }
    ) });
  }
);
export {
  ze as TimePickerInput
};
